import { getYearMonthDateDayDisplay } from "../../../utils/utils";
import { drawTextInBox, X_ALIGN_LEFT, X_ALIGN_RIGHT, Y_ALIGN_TOP } from "../pdfUtil/drawTextInBox";

// 価格表　ヘッダ部分作成
export const createHeader = (page, supplyOnPage, pageProperties) => {
  const {width, margin, height, headerHeight, fonts, needsOutputNo, sendingAgain} = pageProperties;

  const deliveryDateStr = getYearMonthDateDayDisplay(new Date(supplyOnPage.deliveryDate));
  
  // 表タイトル
  drawTextInBox(
    page, 
    `${supplyOnPage.supplierName}　御中`,
    {x1: margin, x2: width - margin, y1: height - margin, y2: height - margin - 20},
    {size: 16, font: fonts.mincho_font, yAlign: Y_ALIGN_TOP}
  );

  // 出荷日
  drawTextInBox(
    page, 
    `${deliveryDateStr}`,
    {x1: width / 6, x2: width / 2, y1: height - margin - 30, y2: height - margin - headerHeight},
    {size: 15, font: fonts.mincho_font, yAlign: Y_ALIGN_TOP}
  );

  // 社名
  drawTextInBox(
    page, 
    "丸伊伊那青果(株)",
    {x1: width / 2, x2: width - margin, y1: height - margin - 30, y2: height - margin - headerHeight},
    {size: 15, font: fonts.mincho_font, xAlign: X_ALIGN_RIGHT, yAlign: Y_ALIGN_TOP}
  );

  // 発注区分番号
  if (needsOutputNo) {
    drawTextInBox(
      page, 
      "No." + supplyOnPage.supplyDivisionId.toString(),
      {x1: width -margin - 50, x2: width - margin, y1: height - margin, y2: height - margin - 20},
      {size: 15, font: fonts.mincho_font, xAlign: X_ALIGN_RIGHT, yAlign: Y_ALIGN_TOP}
    );
  }

  // 再送
  if (sendingAgain) {
    drawTextInBox(
      page, 
      "再送",
      {x1: width - margin - 100, x2: width - margin  - 50, y1: height - margin, y2: height - margin - 20},
      {size: 15, font: fonts.mincho_font, xAlign: X_ALIGN_LEFT, yAlign: Y_ALIGN_TOP}
    ); 
  }

}